let map, marker, geocoder, coverageCircle, branchInfo;
let envio_valido = false; // Variable global para tracking del estado de validación de envío
let mapLoadAttempts = 0; // Evita un bucle infinito de recarga del mapa
// Note: place is already declared globally in the HTML, so we don't redeclare it here

async function initMap() {
    try {
        // Limpiar estado previo de envío
        sessionStorage.removeItem('shipping_confirmed');
        sessionStorage.removeItem('shipping_cost');
        envio_valido = false;
        
        const url = `${baseurl}/api/Select_datos_map`;
        const response = await fetch(url);
        const data = await response.json();

        if (!Array.isArray(data) || !data[0]) {
            // Sin sucursal seleccionada aún: se cargará al elegir una sucursal
            return;
        }

        branchInfo = data[0];
        document.getElementById('addressInput').value = '';
        const tipoArea = branchInfo.tipo_area;
        const datosArea = JSON.parse(branchInfo.datos_area);

        const cedisCoords = JSON.parse(branchInfo.cedis_area).cedis;

        map = new google.maps.Map(document.getElementById('map'), {
            zoom: 12,
            center: datosArea.centro
        });

        geocoder = new google.maps.Geocoder();

        marker = new google.maps.Marker({
            map: map,
            draggable: true
        });

        marker.addListener('dragend', function() {
            const position = marker.getPosition();
            const pos = { lat: position.lat(), lng: position.lng() };
            geocodePosition(pos);
            checkCoverageAndCalculate(pos, cedisCoords, tipoArea, datosArea, branchInfo);
        });

        if (tipoArea === 'circunferencia') {
            coverageCircle = new google.maps.Circle({
                strokeColor: '#72bc6c',
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: '#cce9c9',
                fillOpacity: 0.35,
                map: map,
                center: datosArea.centro,
                radius: datosArea.radio
            });
        }

        const input = document.getElementById('addressInput');
        const autocomplete = new google.maps.places.Autocomplete(input);
        autocomplete.bindTo('bounds', map);

        // Limpiar sessionStorage cuando el usuario cambie manualmente la dirección
        input.addEventListener('input', function() {
            sessionStorage.removeItem('shipping_confirmed');
            sessionStorage.removeItem('shipping_cost');
            envio_valido = false;
            if (typeof place !== 'undefined') {
                place = null; // Limpiar la variable place también
            }
        });

        autocomplete.addListener('place_changed', function() {
            place = autocomplete.getPlace();
            if (!place.geometry || !place.geometry.location) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'El lugar no tiene una ubicación geográfica definida.',
                    customClass: {
                        popup: 'swal',
                    },
                    footer: '<a href="https://api.whatsapp.com/send/?phone=' + branchInfo.numeroTel + '&text=' +
                        encodeURIComponent('Hola, estoy experimentando problemas técnicos con el mapa.') +
                        '&app_absent=0">Reportar este problema vía WhatsApp</a>'
                });
                return;
            }

            const destinationCoords = {
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng()
            };

            marker.setPosition(destinationCoords);
            map.setCenter(destinationCoords);
            checkCoverageAndCalculate(destinationCoords, cedisCoords, tipoArea, datosArea, branchInfo);
        });

    } catch (error) {
        if (mapLoadAttempts < 3) {
            mapLoadAttempts++;
            reloadMap();
        }
    }
}

function geocodePosition(position) {
    geocoder.geocode({ location: position }, function(results, status) {
        if (status === 'OK') {
            if (results[0]) {
                document.getElementById('addressInput').value = results[0].formatted_address;
            } else {
                document.getElementById('addressInput').value = 'No se encontraron resultados';
            }
        } else {
            document.getElementById('addressInput').value = 'Geocoder falló debido a: ' + status;
        }
    });
}

function checkCoverageAndCalculate(position, cedisCoords, tipoArea, datosArea, branchInfo) {
    let isInCoverage = false;

    if (tipoArea === 'circunferencia') {
        isInCoverage = google.maps.geometry.spherical.computeDistanceBetween(
            new google.maps.LatLng(position.lat, position.lng), coverageCircle.getCenter()) <= coverageCircle.getRadius();
        handleCoverage(isInCoverage, position, cedisCoords, branchInfo);
    } else if (tipoArea === 'localidades') {
        geocoder.geocode({ location: position }, function(results, status) {
            if (status === 'OK' && results[0]) {
                const locality = results[0].address_components.find(component =>
                    component.types.includes("locality")
                );
                if (locality && datosArea.localidades.includes(locality.long_name)) {
                    isInCoverage = true;
                }
                handleCoverage(isInCoverage, position, cedisCoords, branchInfo);
            }
        });
    }
}

function handleCoverage(isInCoverage, position, cedisCoords, branchInfo) {
    envio_valido = false;
    if (isInCoverage) {
        envio_valido = true;
        calculateRouteDistance(cedisCoords, position);
    } else {
        document.getElementById('addressInput').value="";
        
        // Limpiar información de envío del sessionStorage cuando está fuera de cobertura
        sessionStorage.removeItem('shipping_confirmed');
        sessionStorage.removeItem('shipping_cost');

        Swal.fire({
            icon: 'error',
            title: 'Fuera de Cobertura',
            text: 'No hay cobertura de entrega para la dirección especificada. Puedes enviar un WhatsApp para confirmar cobertura.',
            customClass: {
                popup: 'swal',
            },
            footer: '<a href="https://api.whatsapp.com/send/?phone=' + branchInfo.numeroTel + '&text=' +
                encodeURIComponent('Hola, ¿me podría verificar la cobertura a la siguiente dirección: ' + document.getElementById('addressInput').value) + '?&app_absent=0">Quiero verificar la cobertura de entrega</a>'
        });
    }
}

function calculateRouteDistance(baseCoords, destinationCoords) {
    Swal.fire({
        title: 'Calculando',
        html: 'Consultando datos...',
        footer: '<p class="color-grisBajo no-margin">No cierre la página</p>',
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        customClass: {
            popup: 'swal',
        },
        didOpen: () => {
            Swal.showLoading();
            const directionsService = new google.maps.DirectionsService();
            const request = {
                origin: new google.maps.LatLng(baseCoords.lat, baseCoords.lng),
                destination: new google.maps.LatLng(destinationCoords.lat, destinationCoords.lng),
                travelMode: 'DRIVING'
            };

            directionsService.route(request, async function(result, status) {
                if (status === 'OK') {
                    const routeDistance = result.routes[0].legs[0].distance.value / 1000;

                    const totalCost = await fetchShippingCost(routeDistance);

                    if (totalCost !== null) {
                        // Guardar información de envío confirmado en sessionStorage
                        sessionStorage.setItem('shipping_confirmed', 'true');
                        sessionStorage.setItem('shipping_cost', totalCost.toString());
                        
                        Swal.fire({
                            icon: 'success',
                            title: '¡Perfecto!',
                            text: 'El costo de envío será de $' + totalCost.toFixed(2) + '. Ya puedes continuar.',
                            customClass: {
                                popup: 'swal',
                            },
                            timer: 4000,
                            showConfirmButton: true,
                            confirmButtonText: 'Entendido'
                        });
                    } else {
                        // Limpiar información de envío del sessionStorage en caso de error
                        sessionStorage.removeItem('shipping_confirmed');
                        sessionStorage.removeItem('shipping_cost');
                        
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'No se pudo calcular el costo de envío correctamente.',
                            customClass: {
                                popup: 'swal',
                            }
                        });
                        document.getElementById('addressInput').value="";
                    }
                } else {
                    // Limpiar información de envío del sessionStorage en caso de error de ruta
                    sessionStorage.removeItem('shipping_confirmed');
                    sessionStorage.removeItem('shipping_cost');
                    
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'No se pudo calcular la ruta correctamente. Estado: ' + status,
                        customClass: {
                            popup: 'swal',
                        },
                        footer: '<a href="https://api.whatsapp.com/send/?phone=' + branchInfo.numeroTel + '&text=' +
                            encodeURIComponent('Hola, estoy teniendo problemas para calcular la ruta.') + '&app_absent=0">Reportar este problema vía WhatsApp</a>'
                    });
                    document.getElementById('addressInput').value="";

                }
            });
        }
    });
}

async function fetchShippingCost(routeDistance) {
    const datos = new FormData();
    datos.append('distance', routeDistance);

    const url = `${baseurl}/calcular_envio`;
    try {
        const respuesta = await fetch(url, {
            method: 'POST',
            body: datos
        });

        const resultado = await respuesta.json();
        console.log('Shipping response:', resultado); // Para debugging
        
        if (resultado.success && resultado.cost !== undefined) {
            return resultado.cost;
        } else {
            console.error('Invalid shipping response:', resultado);
            return null;
        }
    } catch (error) {
        console.error('Error fetching shipping cost:', error);
        return null;
    }
}

function reloadMap() {
    // Elimina el mapa actual
    const mapElement = document.getElementById('map');
    mapElement.innerHTML = '';

    // Carga el mapa nuevamente
    initMap();
}
